import { useLogOutMutation } from "@/data/queries"
import { useAuthTokensAtom } from "@/data/store"
import { isTokenExpired } from "@/model/Jwt"
import { ROUTES } from "@/routes"
import { ReactElement, useEffect } from "react"
import { useNavigate } from "react-router"

type RouterProps = {
  component: ReactElement
}
const ProtectedRoute = (props: RouterProps) => {
  const { component } = props
  const [authTokens] = useAuthTokensAtom()
  const navigate = useNavigate()
  const { mutate: logOut, isPending: isLoggingOut } = useLogOutMutation()

  useEffect(() => {
    if (authTokens && isTokenExpired(authTokens.refreshJwt)) {
      logOut(undefined) // Sets user to null
    }
    if (!authTokens) {
      navigate(ROUTES.LOGIN)
    }
  }, [navigate, authTokens, logOut])

  if (!authTokens || isLoggingOut) {
    return null
  }

  return component
}

export default ProtectedRoute
